module.exports = __webpack_public_path__ + "static/template_options_week_column-cb12e909b3214d0493ad6325f75cc8ae.png";